export let searchRules = {}

export let formRules = {
  received_amount: [
    {required: true, message: '回款金额不能为空', trigger: 'blur'},
  ],
  received_payment_time: [
    {required: true, message: '回款日期不能为空', trigger: 'blur'},
  ],
  attached_file: [
    {required: true, message: '回款附件不能为空', trigger: 'blur'},
  ],
}



// WEBPACK FOOTER //
// ./src/views/invoice-apply/received-payment.rules.js